/**
 * @generated SignedSource<<d83e0350353c863e813f5c4b1f9daed4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthenticationOpenidForm_openidAuth",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signInUrl",
      "storageKey": null
    }
  ],
  "type": "SsoOpenidAuthenticationConfig",
  "abstractKey": null
};

node.hash = "58f48f29c3e0d19fda20ea9c0d05831a";

module.exports = node;
